export const bookingOpeningTimes = {
  1: { open: true, start: '09:00', end: '17:00' }, // Monday
  2: { open: true, start: '09:00', end: '17:00' }, // Tuesday
  3: { open: true, start: '09:00', end: '17:00' }, // Wednesday
  4: { open: true, start: '09:00', end: '17:00' }, // Thursday
  5: { open: true, start: '09:00', end: '17:00' }, // Friday
  6: { open: true, start: '10:00', end: '14:00' }, // Saturday
  7: { open: false, start: null, end: null },      // Sunday
};
